import { type PayoutTraderOrder } from '~/entities/payout';
import { MODALS } from '~/shared/constants/modals';
import { openResponsiveModal } from '~/shared/ui/ResponsiveModals';

export const openTraderOrderModal = (order: PayoutTraderOrder) => {
    const modalIdSuffix = order.id?.value || crypto.randomUUID();

    return openResponsiveModal({
        modal: MODALS.PAYOUT_TRADER_ORDER,
        modalId: `${MODALS.PAYOUT_TRADER_ORDER}_${modalIdSuffix}`,
        title: 'Детали ордера',
        innerProps: {
            order,
        },
    });
};
